export const LINK_LINKTREE = 'https://linktr.ee/KappaThetaTau';
